export default __webpack_public_path__ + "static/media/connectivite.9c49ee06.jpg";